import BigNumber from 'bignumber.js'

import { Network } from '@root/entities/network'
import { WalletAddress, WalletId } from '@root/entities/wallet'

import type { UserApi } from '@root/shared/api'

export interface ProfileWallet {
  network: Network.Network
  id: WalletId
  address: WalletAddress
  name: string
  color: string
  balance: {
    usd: BigNumber
    native: BigNumber
  }
  lastSyncedAt: Date | undefined
}

export const fromDto = (dto: UserApi.UserProfileWalletDto): ProfileWallet => {
  return {
    network: Network.fromDto(dto.network),
    id: WalletId(dto.walletId),
    address: WalletAddress(dto.address),
    name: dto.name ?? '',
    color: dto.color,
    balance: {
      usd: BigNumber(dto.balance.usd),
      native: BigNumber(dto.balance.native),
    },
    lastSyncedAt: dto.lastSyncedAt ? new Date(dto.lastSyncedAt) : undefined,
  }
}
